export const formatPrice = (price: number): string => {
  if (price % 1 === 0) {
    return `${price} kr.`;
  }
  return `${price.toFixed(2).replace(".", ",")} kr.`;
};
